import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    alertAnatomy.keys
);

const baseStyle = definePartsStyle({
    container: {
        borderRadius: '4px',
        borderStyle: 'solid',
        fontSize: 'sm',
        padding: '12px',
        gap: '8px'
    },
    title: {
        fontWeight: 'semibold',
        marginBottom: '4px',
        fontSize: 'md'
    },
    description: {
        fontSize: 'sm',
        lineHeight: '1.5'
    },
    icon: {
        width: '20px',
        height: '20px',
        flexShrink: 0
    }
});

const variants = {
    info: definePartsStyle({
        container: {
            background: 'secondary.100',
            color: 'secondary.700',
            borderWidth: '1px',
            borderColor: 'secondary.300',
            borderInlineStartWidth: '4px',
            borderInlineStartColor: 'secondary.300'
        },
        icon: {
            color: 'secondary.700'
        }
    }),
    success: definePartsStyle({
        container: {
            background: 'success.100',
            color: 'success.700',
            borderWidth: '1px',
            borderColor: 'success.300',
            borderInlineStartWidth: '4px',
            borderInlineStartColor: 'success.300'
        },
        icon: {
            color: 'success.700'
        }
    }),
    warning: definePartsStyle({
        container: {
            background: 'warning.100',
            color: 'warning.700',
            borderWidth: '1px',
            borderColor: 'warning.700',
            borderInlineStartWidth: '4px',
            borderInlineStartColor: 'warning.700'
        },
        icon: {
            color: 'warning.700'
        }
    }),
    error: definePartsStyle({
        container: {
            background: 'error.100',
            color: 'error.700',
            borderWidth: '1px',
            borderColor: 'error.300',
            borderInlineStartWidth: '4px',
            borderInlineStartColor: 'error.300'
        },
        icon: {
            color: 'error.700'
        }
    }),
    neutral: definePartsStyle({
        container: {
            background: 'neutral.100',
            color: 'neutral.700',
            borderWidth: '1px',
            borderColor: 'neutral.300',
            borderInlineStartWidth: '4px',
            borderInlineStartColor: 'neutral.300'
        },
        icon: {
            color: 'neutral.700'
        }
    })
};

export const alertTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: 'info'
    }
});
